import { Input as RsuiteInput } from 'rsuite';
import './index.css';

const DataInput = ({ 
  label, 
  placeholder = "", 
  value = "", 
  onChange, 
  disabled = false,
  type = "text",
  size = "lg",
  maxLength,
  regex,
  formatter,
  prefix,
  suffix,
  multiline = false,
  rows = 3,
  autoComplete = "off",
  'data-testid': dataTestId,
  ...props 
}) => {
  
  const handleChange = (val, event) => {
    let processedValue = val;
    
    // Apply regex filtering if provided
    if (regex && typeof processedValue === 'string') {
      const regexPattern = new RegExp(regex, 'g');
      const matches = processedValue.match(regexPattern);
      processedValue = matches ? matches.join('') : '';
    }
    
    // Apply custom formatter if provided
    if (formatter && typeof formatter === 'function') {
      processedValue = formatter(processedValue);
    }
    
    // Apply maxLength if provided
    if (maxLength && processedValue.length > maxLength) {
      processedValue = processedValue.slice(0, maxLength);
    }
    
    if (onChange) {
      // Create a synthetic event object for compatibility
      const syntheticEvent = {
        target: {
          value: processedValue,
          name: event?.target?.name || ''
        },
        preventDefault: () => {},
        stopPropagation: () => {}
      };
      onChange(syntheticEvent);
    }
  };

  const inputProps = {
    className: "custom-data-input",
    placeholder,
    value: value || "",
    onChange: handleChange,
    disabled,
    size,
    autoComplete,
    style: { width: '100%' },
    ...props
  };

  // Handle different input types
  if (type === 'number') {
    inputProps.type = 'number';
  } else if (type === 'email') {
    inputProps.type = 'email';
  } else if (type === 'password') {
    inputProps.type = 'password';
  } else if (type === 'tel') {
    inputProps.type = 'tel';
  }
  return (
    <div className={`custom-data-input-wrapper ${prefix ? 'has-prefix' : ''} ${suffix ? 'has-suffix' : ''}`}>
      {label && <label className="custom-data-input-label">{label}</label>}
      <div className="custom-data-input-container">
        {prefix && <span className="custom-data-input-prefix">{prefix}</span>}
        {multiline ? (
          <RsuiteInput
            data-testid={dataTestId}
            as="textarea"
            rows={rows}
            {...inputProps}
          />
        ) : (
          <RsuiteInput
            data-testid={dataTestId}
            {...inputProps}
          />
        )}
        {suffix && <span className="custom-data-input-suffix">{suffix}</span>}
      </div>
    </div>
  );
};

export default DataInput;
